<style lang="scss" scoped>

.fade-enter-active, .fade-leave-active {
    transition: all 0.2s ease;
}

.fade-enter-from, .fade-leave-to {
    transform: translateY(-20%);
    opacity: 0;
}

</style>

<template>
    <transition name="fade_">
    <div v-show="spinner && loading_" class="progress progress-sm mb-2">
        <div class="progress-bar progress-bar-indeterminate bg-blue"></div>
    </div>
    </transition>

    <transition name="fade_">
    <div v-show="!loading_">
        <div v-if="isSensorSelected" class="card">
            <transition name="fade">
            <div class="list-group list-group-flush list-group-hoverable">
                <div class="list-group-item">
                    <SensorItem :sensor="sensor" @removeSensor="removeSensorFromProfile" :isRemovable="true"></SensorItem>
                </div>
            </div>
            </transition>
        </div>
        <div v-else-if="isSensorAvailable">
            <transition name="fade">
            <div v-show="!show.sensorList" class="btn btn-white w-100" @click="showSensorList">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon text-blue" width="24" height="24"
                viewBox="2 2 20 20" stroke-width="2.5" stroke="currentColor" fill="none" stroke-linecap="round"
                stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M20 11a8.1 8.1 0 0 0 -6.986 -6.918a8.095 8.095 0 0 0 -8.019 3.918" />
                    <path d="M4 13a8.1 8.1 0 0 0 15 3" />
                    <path d="M19 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                    <path d="M5 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                    <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                </svg>
                <span v-if="parameterId == 'n'" class="text-black">
                    Daten von Niederschlagssensor importieren
                </span>
                <span v-else-if="parameterId == 'e'" class="text-black">
                    Daten von Wasserzählersensor importieren
                </span>
                <span v-else class="text-black">
                    Daten von Sensor importieren
                </span>
            </div>
            </transition>
            
            <transition name="fade" @after-enter="$refs.sensorId.focus()">
            <div v-show="show.sensorList" class="col-12">
                <select ref="sensorId" v-model="sensorId" class="form-select" @change="addSensorToProfile(sensorId)" @focusout="hideSensorList">
                    <option :value="null">
                        Bitte einen Sensor wählen
                    </option>
                    <option v-for="option in sensorList" :key="option.id" :value="option.id" :title="option.label">
                        {{ option.label }}
                    </option>
                </select>
            </div>
            </transition>
        </div>
        <div v-else class="btn btn-white w-100">
            <transition name="fade">
            <router-link :to="{name: 'sensors'}" class="text-black text-decoration-none">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon text-blue" width="24" height="24"
                viewBox="2 2 20 20" stroke-width="2.5" stroke="currentColor" fill="none" stroke-linecap="round"
                stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M20 11a8.1 8.1 0 0 0 -6.986 -6.918a8.095 8.095 0 0 0 -8.019 3.918" />
                    <path d="M4 13a8.1 8.1 0 0 0 15 3" />
                    <path d="M19 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                    <path d="M5 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                    <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                </svg>
                <span v-if="parameterId == 'n'" class="text-black">
                    Lokalen Niederschlagssensor einbinden
                </span>
                <span v-else-if="parameterId == 'e'" class="text-black">
                    Lokalen Wasserzählersensor einbinden
                </span>
                <span v-else class="text-black">
                    Lokale Sensorik einbinden
                </span>
            </router-link>
            </transition>
        </div>
    </div>
    </transition>
    <component :is="confirmRemoveFromProfile" class="mt-1" :show="confirm.removeSensorFromProfile" @cancel="cancelRemoveFromProfile"  @confirm="removeSensorFromProfile(sensor)"></component>
</template>

<script>

import axios from 'axios';
import SensorItem from '@/components/sensor/SensorItem.vue';

export default {
    name: 'SensorSelect',
    components: {
        SensorItem
    },
    inject: [
        'state',
        'config'
    ],
    props: {
        profile: {
            type: Object,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        select: {
            type: Boolean,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        },
        spinner: {
            type: Boolean,
            default: false
        },
        confirmRemoveFromProfile: {
            type: Object,
            default: null
        },
        parameterId: {
            type: String,
            default: ''
        }
    },
    emits: [
        'addSensorToProfile',
        'removeSensorFromProfile',
        'loading',
        'click'
    ],
    data: function () {
        return {
            sensorId: null,
            sensorList: [],
            show: {
                sensorList: false,
            },
            confirm: {
                removeSensorFromProfile: false
            },
            loading_: false
        }
    },
    computed: {
        isSensorSelected: function () {
            if (this.sensor) {
                return true;
            } 
            return false;
        },
        isSensorAvailable: function () {
            return this.sensorList.length > 0;
        },
        sensor: function () {
            const self = this;
            const profile = self.state.profile.item();
            let sensors = [];
            
            if (profile && Array.isArray(profile.sensors)) {
                sensors = profile.sensors.filter( function(sensor) {
                    return sensor.parameterId === self.parameterId;
                });
            }
            
            if (sensors.length > 0) {
                return sensors[0];
            }
            return null;
        },
    },
    methods: {
        addSensorToProfile: function(sensorId, callback) {
            const self = this;
            
            let query = {
                query: `
                mutation (
                    $profileId: Int!
                    $year: Int!
                    $sensorId: Int!
                ) {
                    addSensorToProfile (
                        profileId: $profileId 
                        year: $year
                        sensorId: $sensorId
                    ) {
                        user {
                            profile (profileId: $profileId, year: $year) {
                                id
                                sensors {
                                    id
                                    label
                                    parameterId
                                    labelParameter
                                    userId
                                    sharedUserIds
                                    providerSensorId
                                    isEmbedded
                                    isOwnSensor
                                    errors
                                    lastUpdate
                                    isUsed
                                    isImportActive
                                    sensorDataYears
                                }
                            }
                            loggedIn
                        }
                    }
                }
                `,      
                variables:  {
                    profileId: this.state.profile.id,
                    year: self.profile.year,
                    sensorId: sensorId
                }
            }
            
            
            const request = Object.assign({}, self.config.request, {data: query});
            self.loading_ = true;
            
            axios(request).then( function(response) {
                
                response.handler( function(data){
                    self.state.actions.profile.set({
                        sensors: data.addSensorToProfile.user.profile.sensors
                    })
                    
                    self.sensorId = null;
                    self.show.sensorList = false;
                    
                    self.$emit('addSensorToProfile', data.addSensorToProfile.user.profile.sensors);
                });
             
            }).catch(function (error) {
                console.log(error);
            }).then(function () {
                self.loading_ = false;
                
                if (callback) {
                    callback(self);
                }
            });

        },
        cancelRemoveFromProfile: function() {
            this.confirm.removeSensorFromProfile = false;
        },
        removeSensorFromProfile: function(sensor, callback) {
            const self = this;
            
            if (self.confirmRemoveFromProfile && self.confirm.removeSensorFromProfile == false) {
                self.confirm.removeSensorFromProfile = true;
                return
            }
            self.confirm.removeSensorFromProfile = false;
            
            
            if (self.preventRemoveFromProfile) {
                console.log(self.preventRemoveFromProfile);
                return;
            }
            
            let query = {
                query: `
                mutation (
                    $profileId: Int!
                    $year: Int!
                    $sensorId: Int!
                ) {
                    removeSensorFromProfile (
                        profileId: $profileId
                        year: $year                        
                        sensorId: $sensorId
                    ) {
                        user {
                            profile (profileId: $profileId, year: $year) {
                                id
                                sensors {
                                    id
                                    label
                                    parameterId
                                    labelParameter
                                    userId
                                    sharedUserIds
                                    providerSensorId
                                    isEmbedded
                                    isOwnSensor
                                    errors
                                    lastUpdate
                                    isUsed
                                    isImportActive
                                    sensorDataYears
                                }
                            }
                            loggedIn
                        }
                    }
                }
                `,      
                variables:  {
                    profileId: this.state.profile.id,
                    year: self.profile.year,
                    sensorId: sensor.id
                }
            }
            
            const request = Object.assign({}, self.config.request, {data: query});
            self.loading_ = true;
            
            axios(request).then( function(response) {
                
                response.handler( function(data){
                    self.state.actions.profile.set({
                        sensors: data.removeSensorFromProfile.user.profile.sensors
                    })
                    
                    self.sensorId = null;
                    self.show.sensorList = false;
                    
                    self.$emit('removeSensorFromProfile', data.removeSensorFromProfile.user.profile.sensors);
                });
             
            }).catch(function (error) {
                // console.log(error);
            }).then(function () {
                self.loading_ = false;
                
                if (callback) {
                    callback(self);
                }
            });

        },
        fetchSensors: function(callback) {
            const self = this;
            
            let query = {
                query: `
                query (
                    $parameterId: String
                    $profileId: Int!
                    $year: Int
                ) {
                    user {
                        profile (profileId: $profileId, year: $year) {
                            id
                            sensors {
                                id
                                label
                                parameterId
                                labelParameter
                                userId
                                sharedUserIds
                                providerSensorId
                                isEmbedded
                                isOwnSensor
                                errors
                                lastUpdate
                                isUsed
                                isImportActive
                                sensorDataYears
                            }
                        }
                        sensors (parameterId: $parameterId) {
                            id
                            label
                            parameterId
                            labelParameter
                            userId
                            sharedUserIds
                            providerSensorId
                            isEmbedded
                            isOwnSensor
                            errors
                            lastUpdate
                            isUsed
                            isImportActive
                            sensorDataYears
                        }
                        loggedIn                        
                    }                    
                }     
                `,      
                variables: {
                    parameterId: self.parameterId,
                    profileId: self.state.profile.id,
                    year: self.profile.year
                }
            }
            
            const request = Object.assign({}, self.config.request, {data: query});
            self.loading_ = true;
            
            axios(request).then( function(response) {
                
                response.handler( function(data){
                    // List of available sensors
                    self.sensorList = data.user.sensors;
                    // List of sensors bound to profile for the calculation year
                    self.state.actions.profile.set({sensors: data.user.profile.sensors});
                    // self.$emit('addSensorToProfile', data.user.profile.sensors);
                });
             
            }).catch(function (error) {
                console.log(error);
            }).then(function () {
                self.loading_ = false;
                
                if (callback) {
                    callback(self);
                }
            });
        },
        showSensorList: function() {
            const self = this;
            self.$emit('click', this.$event)
            
            if (self.select !== null) {
                return;
            }
            self.show.sensorList = true;
        },
        hideSensorList: function()  {
            if (this.loading_ === false) {
                this.show.sensorList = false;
            }
        }
    },
    watch: { 
        loading_: function (newValue, oldValue) {
            if (oldValue !== newValue) {
                this.$emit('update:loading', newValue);
            }
        },
        select: function (newValue, oldValue) {
            if (newValue === true) {
                this.show.sensorList = true;
            }
        }        
    },
    created: function()  {
        this.fetchSensors();
    }
}

</script>